import React, { useEffect, useState } from "react";
import Layout from "../../Layout/Layout";
import ScheduleList from "./ScheduleList";
import GetSvgIcon from "../../../images/svglist";
import { CallApiGet, CallApiPost } from "../../Helper/serviceApi";
import UploadCharteredSchedule from "./UploadCharteredSchedule";
import {
  BLACK_SPCL_CHARS,
  DATE_FORMAT_SERVER,
  DATE_TIME_FORMAT_MOMENT,
  REQUIRED_ERR_MSG,
  SERVER_ERR_MSG,
} from "../../Helper/Constants";
import moment from "moment";
import SchedulePlan from "./SchedulePlan";
import ModalConfirmAlert from "../../Layout/ModalConfirmAlert";
import { getUserInfo } from "../../AuthUtils/AuthUtils";
import {
  CHARTERED_WGT_SRVC_ID,
  LINEHAUL_ADMIN_USER_TYPE,
  LINEHAUL_STAFF_USER_TYPE,
} from "../../../ConfigConstants/ConfigConstants";
import BookingModal from "./BookingModal";
import CharteredRateSummary from "../../OrderBooking/ChartaredOrderBooking/CharteredRateSummary";
import VhclDrPlanning from "./VhclDrPlanning";
import { numberInputOnWheelPreventChange } from "../../Helper/CommonMethods";

const initAlertConfig = {
  isSuccess: false,
  size: "",
  show: false,
  title: "",
  description: "",
};

const initModalConfig = {
  show: false,
  fullscreen: true,
  modalType: "",
  data: {
    planId: 0,
    routeId: 0,
    routeCode: "",
    planSts: 0,
    remark: "",
    status: "",
    tripStart: "",
    validFrom: "",
    validTo: "",
    driver1Id: 0,
    driver2Id: 0,
    truckId: 0,
    origin: "",
    orgAddr: "",
    orgCity: "",
    orgState: "",
    orgPostcode: "",
    originId: 0,
    originSbuCode: "",
    destination: "",
    destAddr: "",
    destCity: "",
    destState: "",
    destPostcode: "",
    destnationId: 0,
    destinationSbuCode: "",
    itinerary: "[]",
  },
};
const initSearchParam = {
  dateFrom: moment().subtract(1, "days").format(DATE_FORMAT_SERVER),
  dateTo: moment().add(1, "days").format(DATE_FORMAT_SERVER),
};
const initDropdownOpt = {
  vhclOpts: [],
  planStsOpts: [],
  driverOpts: [],
};

const initOrdSummaryConfig = {
  show: false,
  title: "",
};

const initConfirmConfig = {
  show: false,
  size: "sm",
  title: "",
  data: "",
  modalType: "",
};

const initChartModal = {
  show: false,
  title: "",
};

const initCancelReason = {
  value: "",
  error: false,
};

const ScheduleMain = () => {
  const [showSpinner, setShowSpinner] = useState(false);
  const [uploadType, setUploadType] = useState("");
  const [alertConfig, setAlertConfig] = useState(initAlertConfig);
  const [scheduleList, setScheduleList] = useState([]);
  const [searchParams, setSearchParams] = useState(
    Object.assign({}, initSearchParam)
  );
  const [modalConfig, setModalConfig] = useState(
    Object.assign({}, initModalConfig)
  );
  const [dropdownOpts, setDropdownOpts] = useState(
    Object.assign({}, initDropdownOpt)
  );
  const [confirmAlertConfig, setConfirmAlertConfig] = useState(
    Object.assign({}, initConfirmConfig)
  );
  const [selPlan, setSelPlan] = useState(Object.assign({}, modalConfig.data));

  const [bookModalConfig, setBookModalConfig] = useState(
    Object.assign({}, initAlertConfig)
  );

  const [ChartRateModalConfig, setChartRateModalConfig] = useState(
    Object.assign({}, initChartModal)
  );

  const [rateOrdDetails, setRateOrdDetails] = useState([]);

  const [message, setMessage] = useState(null);

  const [addTruckModalConfig, setAddTruckModalConfig] = useState(
    Object.assign({}, initConfirmConfig)
  );
  const [cancelconfirmConfig, setCancelconfirmConfig] = useState(
    Object.assign({}, initAlertConfig)
  );
  const [cancelReason, setCancelReason] = useState(
    Object.assign({}),
    initCancelReason
  );
  const [ordId, setOrdId] = useState(0);

  const openRouteDetls = async (rowData, modalType) => {
    setShowSpinner(true);
    const payload = {
      partnerId: 0,
      vhclType: !!rowData?.ordVhclTypeId ? rowData?.ordVhclTypeId : 0,
      noLessSize: true,
    };
    let copyRowData;
    Promise.all([
      CallApiGet(`GetPlanDtlsById?planId=${rowData?.planId}`),
      CallApiPost("getVehicleList", payload),
    ]).then(([planData, vhclType]) => {
      let error = false;
      if (
        planData?.respCode === 200 &&
        !!planData?.respData &&
        planData?.respData?.length > 0
      ) {
        copyRowData = Object.assign({}, planData.respData[0]);
        copyRowData.itinerary = JSON.parse(copyRowData.itinerary);
        copyRowData.itinerary[0].std = "00:00";
        copyRowData.ordVhclTypeId = !!rowData?.ordVhclTypeId
          ? rowData?.ordVhclTypeId
          : 0;
        copyRowData.ordVhclTypeTxt = rowData?.ordVhclTypeTxt;
        copyRowData.rateType = rowData?.rateType;
        copyRowData.rateTypeTxt = rowData?.rateTypeTxt;
      } else {
        error = true;
      }

      if ([0, 200].includes(vhclType.respCode) && !!vhclType.respData) {
        setDropdownOpts({
          ...dropdownOpts,
          vhclOpts: vhclType.respData
            .filter((v) => v.active === true)
            .map((v) => {
              v.label = `${v.label} (${v.vhclTypeName})`;
              return v;
            }),
        });
      } else {
        error = true;
      }

      if (!error) {
        openAddTruckConfig(copyRowData, modalType);
      } else {
        openPopup(false, "ERROR", SERVER_ERR_MSG);
      }
      setShowSpinner(false);
    });
  };

  const onHide = () => {
    setModalConfig(Object.assign({}, initModalConfig));
  };

  const fetchScheduleList = async (payload) => {
    setShowSpinner(true);
    const uri = `GetCharteredPlanList?dateFrom=${payload?.dateFrom}&dateTo=${payload?.dateTo}`;
    let data = await CallApiGet(uri);
    if (data.respCode === 200 || data.respCode === 0) {
      setScheduleList(data.respData);
      const rateTypes = data.respData.map((item) => item.rateTypeTxt);
    } else if (data.respCode === 401) {
      console.error(data);
      openPopup(
        false,
        "UNAUTHORIZED",
        "Sorry, you don't have the read permission!!"
      );
    } else {
      console.error(data);
      openPopup(false, "ERROR", SERVER_ERR_MSG);
    }
    setShowSpinner(false);
  };

  const fetchDropdownOpts = async () => {
    setShowSpinner(true);
    const payload = {
      argDriverUser: 1,
      argPlanStatus: 1,
    };
    const resp = await CallApiPost("GetDropdownOptions", payload);
    if (resp.respCode === 200 && !!resp.respData) {
      setDropdownOpts({
        planStsOpts: resp?.respData?.planStatus,
        driverOpts: resp?.respData?.driverUserArr,
      });
    }
    setShowSpinner(false);
  };

  useEffect(() => {
    fetchScheduleList(searchParams);
    fetchDropdownOpts();
  }, []);

  const hideAlert = () => {
    setAlertConfig({
      isSuccess: false,
      size: "md",
      show: false,
      title: "",
      description: "",
    });
    fetchScheduleList(searchParams);
  };

  const openPopup = (bool, title, desc) => {
    setAlertConfig({
      isSuccess: bool,
      size: "md",
      show: true,
      title: title,
      description: desc,
    });
  };

  const handleChange = (key, value) => {
    if (!!value) {
      setSearchParams({
        ...searchParams,
        [key]: moment(value).format(DATE_FORMAT_SERVER),
      });
    } else {
      setSearchParams({ ...searchParams, [key]: value });
    }
  };

  const onSubmit = () => {
    fetchScheduleList(searchParams);
  };

  const handleApiResponse = (resp) => {
    switch (resp.respCode) {
      case 200:
        openPopup(true, "SUCCESS", resp.respMessage);
        break;
      case 99:
        openPopup(
          false,
          "ERROR",
          "Oops! Something went wrong. Please try after sometime!!"
        );
        break;
      case 500:
        openPopup(
          false,
          "ERROR",
          "Sorry, we failed to process your request due to some techinical error. Please try after sometime!!"
        );
        break;
      default:
        openPopup(false, "ERROR", resp.respMessage);
        break;
    }
  };

  const onSave = async (data) => {
    setShowSpinner(true);
    let stopsArr = [];
    data.itinerary
      .filter((element) => element.stopSeq > 0 && element.stopSeq < 99)
      .forEach((element) => {
        const stop = element.stopSeq + "-S" + element.stopSeq;
        stopsArr.push(stop);
      });

    const routeValidArray = [
      {
        RowIndex: 0,
        RouteCode: data.routeCode,
        StopsStr: stopsArr.join(","),
      },
    ];
    if (addTruckModalConfig?.modalType === "A") {
      data.parentPlanId = data.planId;
      data.isAddTruck = true;
      data.planId = 0;
      const date = moment(data.tripStart, "DD-MM-YYYY HH:mm").format(
        DATE_FORMAT_SERVER
      );
      data.tripStart = moment(`${date} ${data.etd}`).format(
        DATE_TIME_FORMAT_MOMENT
      );
    }
    let payload = {
      routeValidArr: routeValidArray,
      planArr: [data],
    };
    const resp = await CallApiPost("SaveCharteredPlan", payload);
    // onHide();
    handleAddTruckClose();
    if (resp.respCode === 9) {
      resp.respMessage = !!resp.respData[0]?.ErrorMessage
        ? resp.respData[0]?.ErrorMessage
        : resp?.respMessage;
    }
    handleApiResponse(resp);
    setShowSpinner(false);
  };
  const showAlert = (data) => {
    setAlertConfig({
      isSuccess: data.isSuccess,
      size: "md",
      show: true,
      title: data.title,
      description: data.description,
    });
  };
  const resetMessage = () => {
    setMessage("");
  };

  const hideConfirmAlert = () => {
    setConfirmAlertConfig(Object.assign({}, initConfirmConfig));
    setSelPlan(Object.assign({}, modalConfig.data));
  };

  const saveWgtForPlan = async () => {
    setShowSpinner(true);
    selPlan.serviceId = CHARTERED_WGT_SRVC_ID;
    let selPlanList = [];
    selPlanList.push(selPlan);
    const apiResp = await CallApiPost("SetServiceForPlan", selPlanList);
    handleApiResponse(apiResp);
    hideConfirmAlert();
    setShowSpinner(false);
  };

  const unassignTrip = async (data) => {
    setShowSpinner(true);

    const apiResp = await CallApiGet(
      "unassignCharteredTrip?orderId=" + data.order_id
    );
    handleApiResponse(apiResp);
    // hideConfirmAlert();
    setShowSpinner(false);
  };

  const handleOnChange = (event) => {
    const { name, value } = event.target;
    setSelPlan({ ...selPlan, [name]: value });
  };

  const openModalForWgt = (row) => {
    setSelPlan(row);
    setConfirmAlertConfig({
      show: true,
      size: "sm",
      title: "WEIGHT",
    });
  };

  const UploadBtn = () => {
    const userType = getUserInfo("userType");
    const isStaff = [
      LINEHAUL_ADMIN_USER_TYPE,
      LINEHAUL_STAFF_USER_TYPE,
    ].includes(userType);
    return (
      <>
        {isStaff && (
          <div className="float-end d-flex">
            <div className="mt-1">
              <button
                className="btn btn-outline-secondary theme-violet me-1"
                type="button"
                data-bs-toggle="modal"
                data-bs-target="#upload-file-modal"
                onClick={() => setUploadType("D")}
              >
                {GetSvgIcon("IconArrowup")} Upload Driver
              </button>
              <button
                className="btn btn-outline-secondary theme-violet"
                type="button"
                data-bs-toggle="modal"
                data-bs-target="#upload-file-modal"
                onClick={() => setUploadType("P")}
              >
                {GetSvgIcon("IconArrowup")} Upload Schedule
              </button>
            </div>
          </div>
        )}
      </>
    );
  };

  const openBookModal = (row) => {
    setSelPlan(Object.assign({}, row));
    setBookModalConfig({
      show: true,
      size: "lg",
      title: "Order Information",
    });
  };

  const handleCLose = () => {
    setBookModalConfig(Object.assign({}, initAlertConfig));
  };

  const onBook = async (payload) => {
    setShowSpinner(true);
    const resp = await CallApiPost("saveScheduleChartedBooking", payload);
    setShowSpinner(false);
    handleCLose();
    handleApiResponse(resp);
    fetchScheduleList(searchParams);
  };

  const openChartRateConfig = (row) => {
    setRateOrdDetails(row);
    setChartRateModalConfig({
      show: true,
      title: "Chartered Rate Configuration",
    });
  };

  const closeChartRateConfig = () => {
    setChartRateModalConfig({
      show: false,
      title: "",
    });
  };

  const openAddTruckConfig = (argData, argModalType) => {
    setAddTruckModalConfig({
      show: true,
      size: "sm",
      title: "Add Vehicle/Driver",
      modalType: argModalType,
      data: argData,
    });
  };
  const handleAddTruckClose = () => {
    setAddTruckModalConfig({
      show: false,
      size: "",
      title: "",
      modalType: "",
      data: null,
    });
  };

  const handleCxlShipment = (row) => {
    // setSelOrder(Object.assign({}, row));
    setOrdId(row.orderId);
    setCancelconfirmConfig({
      isSuccess: true,
      size: "md",
      show: true,
      title: "Cancel Shipment",
      description: "",
    });
  };

  const hideCancelConfirmAlert = () => {
    setCancelconfirmConfig({
      isSuccess: false,
      size: "",
      show: false,
      title: "",
      description: "",
    });
    setCancelReason(Object.assign({}, initCancelReason));
  };

  const cancelShipment = async () => {
    if (!isDataValid(cancelReason.value)) {
      setCancelReason({
        ...cancelReason,
        error: true,
      });
      return;
    }
    setShowSpinner(true);
    const payload = {
      shipmentId: ordId,
      remarks: cancelReason.value,
    };
    const resp = await CallApiPost("CancelChBooking", payload);
    handleApiResponse(resp);
    hideCancelConfirmAlert();
    setShowSpinner(false);

    closeChartRateConfig();
    // setSelOrder({});
  };
  const isDataValid = (argValue) => {
    if (!!argValue && argValue?.length > 0) {
      return true;
    } else {
      return false;
    }
  };

  const handleCancelOnChange = (event) => {
    const { value } = event.target;
    let copyCancelReason = Object.assign({}, cancelReason);
    if (!BLACK_SPCL_CHARS.test(value)) {
      copyCancelReason.error = false;
      copyCancelReason.value = value;
      setCancelReason(copyCancelReason);
    }
  };

  const openChOrdDetails = (data) => {
    const url = `/charteredOrderDetails?data=${data.order_id}`;
    window.open(url, "_blank");
  };

  return (
    <>
      <div>
        <Layout
          spinnershow={showSpinner}
          alertConfig={alertConfig}
          hideAlert={hideAlert}
        >
          <div className="clearfix border-bottom pb-2 mb-2">
            <div className="float-start">
              <div className="section-title mt-1">Chartered Order Planning</div>
            </div>
            {/* <UploadBtn /> */}
          </div>
          <ScheduleList
            scheduleList={scheduleList}
            onSubmit={onSubmit}
            searchParams={searchParams}
            handleChange={handleChange}
            openRouteDetls={openRouteDetls}
            handleBtnClick={openBookModal}
            openModalForWgt={openModalForWgt}
            openChartRateConfig={openChartRateConfig}
            openAddTruckConfig={openAddTruckConfig}
            unassignTrip={unassignTrip}
            openChOrdDetails={openChOrdDetails}
          />
          {ChartRateModalConfig.show && (
            <CharteredRateSummary
              ChartRateModalConfig={ChartRateModalConfig}
              closeChartRateConfig={closeChartRateConfig}
              rateOrdDetails={rateOrdDetails}
              setShowSpinner={setShowSpinner}
              openPopup={openPopup}
              handleCxlShipment={handleCxlShipment}
            />
          )}
          <UploadCharteredSchedule
            openPopup={openPopup}
            uploadType={uploadType}
          />
          {/* <SchedulePlan
            modalConfig={modalConfig}
            handleClose={onHide}
            dropdownOpts={dropdownOpts}
            onSave={onSave}
          /> */}

          <ModalConfirmAlert
            confirmAlertConfig={confirmAlertConfig}
            hideConfirmAlert={hideConfirmAlert}
            confirmAlert={saveWgtForPlan}
            confirmBtnTxt="SAVE"
          >
            <label
              htmlFor="floatingInputGrid"
              className="form-label theme-label"
            >
              Enter Weight (kg){" "}
            </label>
            <input
              type="number"
              name="serviceValue"
              className="form-control"
              defaultValue={selPlan?.serviceValue}
              onChange={handleOnChange}
              onWheel={(e) => numberInputOnWheelPreventChange(e)}
            />
          </ModalConfirmAlert>
          <ModalConfirmAlert
            confirmAlertConfig={cancelconfirmConfig}
            hideConfirmAlert={hideCancelConfirmAlert}
            confirmAlert={cancelShipment}
            cancelBtnTxt="Not now"
            confirmBtnTxt="Cancel order"
          >
            <div className="row">
              <div className="col-md-3">
                <label
                  htmlFor="floatingInputGrid"
                  className="form-label theme-label"
                >
                  Reason <span className="text-danger">&#9733;</span>
                </label>
              </div>
              <div className="col-md-9 mb-2">
                <input
                  id="cancellation-reason"
                  type="text"
                  className="form-control"
                  name="cancellationReason"
                  value={cancelReason.value}
                  autoComplete="false"
                  onChange={handleCancelOnChange}
                />
                {cancelReason.error && (
                  <div style={{ textAlign: "left" }}>
                    <span className="badge bg-danger">
                      &#9888; This field is required.
                    </span>
                  </div>
                )}
              </div>
            </div>
          </ModalConfirmAlert>
          <BookingModal
            handleCLose={handleCLose}
            bookModalConfig={bookModalConfig}
            selPlan={selPlan}
            onBook={onBook}
          />

          <VhclDrPlanning
            addTruckModalConfig={addTruckModalConfig}
            handleAddTruckClose={handleAddTruckClose}
            dropdownOpts={dropdownOpts}
            onSave={onSave}
          />
        </Layout>
      </div>
    </>
  );
};

export default ScheduleMain;
